import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useMemberMaster from "src/hooks/useMemberMaster";

const AuthRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const { pathname } = location;

  const isMemberMaster = useMemberMaster();

  if (pathname.includes("master")) {
    if (!isMemberMaster) {
      alert("잘못된 접근입니다.");
      return <Navigate to="/" state={{ from: location }} />;
    }
  }

  return children;
};

export default AuthRoute;
